// Global Instructions Rule Applied!
//
// Investments screen — a top-level, multi-fund Investment Detail grid with a
// Summary panel above it. Fund scope, as-of date and the include-* toggles
// live in the Filtering drawer's Options panel (same UI shape as the per-fund
// Fund Investment Detail tab), so there is no top-level selector bar — the
// screen is the Summary panel + the grid (both owned by InvestmentDetailTable).

import React from 'react'
import { InvestmentDetailTable } from './InvestmentDetailTable.tsx'

interface InvestmentsFormProps {
  /** Embedded mode (e.g. the consolidated-fund Investments tab): preset the
   *  fund scope and detach from the standalone screen's user preferences. */
  presetFundIds?: string[]
}

export function InvestmentsForm({ presetFundIds }: InvestmentsFormProps = {}): React.ReactElement {
  return (
    <div className='h-full overflow-hidden'>
      <div className='w-full h-full flex flex-col bg-white p-2 overflow-hidden'>
        <InvestmentDetailTable presetFundIds={presetFundIds} />
      </div>
    </div>
  )
}

export default InvestmentsForm
